import React from 'react';

function SvgEchIconSettings(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={21.62}
          x2={13.37}
          y1={79.15}
          y2={70.9}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <linearGradient
          id={`${iconUuid}_b`}
          x1={74.56}
          x2={42.03}
          y1={91.22}
          y2={58.69}
          xlinkHref={`#${iconUuid}_a`}
        />
        <linearGradient
          id={`${iconUuid}_c`}
          x1={86.62}
          x2={78.37}
          y1={53.93}
          y2={45.68}
          xlinkHref={`#${iconUuid}_a`}
        />
        <linearGradient
          id={`${iconUuid}_d`}
          x1={57.97}
          x2={25.44}
          y1={66.14}
          y2={33.61}
          xlinkHref={`#${iconUuid}_a`}
        />
        <linearGradient
          id={`${iconUuid}_e`}
          x1={74.56}
          x2={42.03}
          y1={41.33}
          y2={8.81}
          xlinkHref={`#${iconUuid}_a`}
        />
        <linearGradient
          id={`${iconUuid}_f`}
          x1={21.62}
          x2={13.37}
          y1={29.27}
          y2={21.02}
          xlinkHref={`#${iconUuid}_a`}
        />
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M10 74.28h15v1.5H10z"
      />
      <path
        fill={`url(#${iconUuid}_b)`}
        stroke={`url(#${iconUuid}_b)`}
        strokeWidth={5}
        d="M37.5 66.64a8.25 8.25 0 108.2 9.14H90v-1.5H45.72a8.25 8.25 0 00-8.22-7.64zm0 15a6.75 6.75 0 116.75-6.75 6.76 6.76 0 01-6.75 6.75z"
      />
      <path
        fill={`url(#${iconUuid}_c)`}
        stroke={`url(#${iconUuid}_c)`}
        strokeWidth={5}
        d="M75 49.05h15v1.5H75z"
      />
      <path
        fill={`url(#${iconUuid}_d)`}
        stroke={`url(#${iconUuid}_d)`}
        strokeWidth={5}
        d="M62.5 58.19a8.25 8.25 0 10-8.2-9.14H10v1.5h44.28a8.25 8.25 0 008.22 7.64zm0-15a6.75 6.75 0 11-6.75 6.75 6.76 6.76 0 016.75-6.75z"
      />
      <path
        fill={`url(#${iconUuid}_e)`}
        stroke={`url(#${iconUuid}_e)`}
        strokeWidth={5}
        d="M45.72 24.39a8.22 8.22 0 100 1.5H90v-1.5zm-8.22 7.36A6.75 6.75 0 1144.25 25a6.76 6.76 0 01-6.75 6.75z"
      />
      <path
        fill={`url(#${iconUuid}_f)`}
        stroke={`url(#${iconUuid}_f)`}
        strokeWidth={5}
        d="M10 24.39h15v1.5H10z"
      />
    </svg>
  );
}
export default SvgEchIconSettings;
